import { getConsents } from '@/pages/avatar/api';
import { useQuery } from 'react-query';

export const GET_CONSENTS_KEY = 'get-consents';

export const useGetConsents = () => {
    return useQuery(GET_CONSENTS_KEY, getConsents, { refetchOnWindowFocus: false });
};
